import Vue from 'vue'
import { getStateProperty } from '@/utils/store'
import * as type from './types'

export default {
  [type.ERROR]: (state, {
    title, message, error, status
  }) => {
    /* eslint-disable-next-line no-param-reassign */
    state.error = {
      title,
      message:
        message
        || (error.response && error.response.data ? error.response.data.message : null)
        || error.message
        || 'Непредвиденная ошибка.',
      code: error.response && error.response.data ? error.response.data.code : -100,
      status: status || (error.response ? error.response.status : 0),
      response: error.response,
      error
    }
  },

  [type.LOADING]: (state, name) => {
    const property = getStateProperty(state, name)
    property.loading = true
  },
  [type.SET_LOADING_MESSAGE]: (state, { name, message }) => {
    const property = getStateProperty(state, name)
    Vue.set(property, 'loadingMessage', message)
  },
  [type.SET_PROMISE_CHAIN]: (state, { name, promise }) => {
    const property = getStateProperty(state, type.COMMON)
    const newPromises = { ...property.loadingPromises, [name]: promise }
    Vue.set(property, 'loadingPromises', newPromises)
  },
  [type.LOADED]: (state, name) => {
    const property = getStateProperty(state, name)
    property.loading = false
  },

  // mutation for locale
  [type.SET_LOCALE]: (state, locale) => {
    const property = getStateProperty(state, type.COMMON)
    Vue.set(property, 'locale', locale)
  },

  // mutation for other module properties
  [type.SET_MODULE_PROPERTY]: (state, { name, key, value }) => {
    const property = getStateProperty(state, name)
    Vue.set(property, key, value)
  },

  // model mutations
  [type.SET_MODEL]: (state, { name, model }) => {
    const property = getStateProperty(state, name)
    Vue.set(property, 'model', model)
  },
  [type.UPDATE_MODEL]: (state, { name, model }) => {
    // eslint-disable-next-line no-param-reassign
    state[name].model = { ...state[name].model, ...model }
  },

  // conversions sync date mutations
  [type.SET_CONVERSIONS_SYNC_DATE]: (state, { name = type.GENERAL_CONFIGURATION, conversionsSyncDate }) => {
    const property = getStateProperty(state, name)
    Vue.set(property, 'conversionsSyncDate', conversionsSyncDate)
  },

  // list mutations
  [type.SET_LIST]: (state, { name, list }) => {
    const property = getStateProperty(state, name)
    Vue.set(property, 'list', list)
  },
  [type.UPDATE_LIST_ITEM_PROPS]: (state, { name, item, props }) => {
    const listItem = state[name].list.find(i => i === item)
    Object.assign(listItem, props)
  },
  [type.SHIFT_LIST]: (state, { name }) => {
    state[name].list.shift()
  },

  // params mutations
  [type.SET_PARAMS]: (state, { name, params }) => {
    const property = getStateProperty(state, name)
    Vue.set(property, 'params', params)
  },
  [type.UPDATE_PARAMS]: (state, { name, params }) => {
    Object.assign(state[name].params, params)
  }
}
